import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { concat } from 'rxjs/observable/concat';
import { ConfigurationService } from 'ionic-configuration-service';
import { AdminService } from '../services/admin.service';
import { SessionService } from '../services/session.service';
import { Platform } from 'ionic-angular';
import { RegionService } from '../services/region.service';

interface SettingOption {
  title: string;
  name: string;
  id?: string;
  type: string;
}

@Injectable()
export class AppInitService {
  defaultRegion: SettingOption;

  constructor(
    private configurationService: ConfigurationService,
    private adminService: AdminService,
    private sessionService: SessionService,
    private regionService: RegionService,
    public plt: Platform
  ) {}

  init(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.services().subscribe(
        () => {},
        (err: any) => reject(err),
        () => {
          resolve();
        }
      );
    });
  }

  services() {
    return concat(this.regionService.init('en'), this.adminService.init(), this.sessionService.init());
  }
}



// WEBPACK FOOTER //
// ./src/app/app-init.service.ts